import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, TS_PropRenderer } from '@nu-art/thunderstorm-frontend';
import { DefaultEditor_InputText } from '@app/styles/frontend/ui-manager/ui-components';
import { FadeScrollWrapper } from '@app/styles';
import { Component_ContextRules } from '../../../../../_enum.js';
import { TS_TextAreaV2 } from '@nu-art/thunderstorm-frontend/components/TS_V2_TextArea/index';
import './Editor_ContextRule.scss';
export class Editor_ContextRule extends ComponentSync {
    shouldComponentUpdate() {
        return true;
    }
    render() {
        return _jsxs(FadeScrollWrapper, { className: 'e__context-rule', children: [this.renderField_Label(), this.renderField_Description(), this.renderField_Rules(), this.props.isNewContextRule && this.renderField_SaveButton()] });
    }
    renderField_Label = () => {
        return _jsx(TS_PropRenderer.Vertical, { label: 'Label', children: _jsx(DefaultEditor_InputText, { editable: this.props.editable, prop: 'label', disabled: !this.props.editMode, showErrorTooltip: true }) });
    };
    renderField_Description = () => {
        return _jsx(TS_PropRenderer.Vertical, { label: 'Description', children: _jsx(TS_TextAreaV2, { type: 'text', value: this.props.editable.item.description ?? '', disabled: !this.props.editMode, onChange: (value) => this.props.editable.updateObj({ description: value }) }) });
    };
    renderField_Rules = () => {
        const editableRules = this.props.editable.editProp('rules', []);
        const editableExcludedVariables = this.props.editable.editProp('excludedVariableIds', []);
        return _jsx(Component_ContextRules, { editableContextRules: editableRules, editMode: this.props.editMode, editableExcludedVariables: editableExcludedVariables });
    };
    renderField_SaveButton = () => {
        return _jsx("button", { className: 'e__context-rule__save-btn', onClick: async () => await this.props.editable.save(), children: "Save" });
    };
}
//# sourceMappingURL=Editor_ContextRule.js.map